import type { NetworkConnectionsFilterableField } from '@kirin/api-client/contracts/shadow-ai';
import { NETWORK_CONNECTIONS_FILTERABLE_FIELDS } from '@kirin/api-client/contracts/shadow-ai';
import { TABLE_IDS } from '@/components/DataTable/tableIds';

/** Short per-column URL keys for state persistence (KIR-3496). */
export const NETWORK_DOMAINS_FILTER_URL_KEYS = {
  [NETWORK_CONNECTIONS_FILTERABLE_FIELDS.PROCESS]: 'proc',
  [NETWORK_CONNECTIONS_FILTERABLE_FIELDS.HOST]: 'host',
  [NETWORK_CONNECTIONS_FILTERABLE_FIELDS.STATUS]: 'st',
  [NETWORK_CONNECTIONS_FILTERABLE_FIELDS.TRAFFIC]: 'traf',
  [NETWORK_CONNECTIONS_FILTERABLE_FIELDS.HITS]: 'hits',
  [NETWORK_CONNECTIONS_FILTERABLE_FIELDS.USERS]: 'usr',
  [NETWORK_CONNECTIONS_FILTERABLE_FIELDS.MACHINES]: 'mach',
  [NETWORK_CONNECTIONS_FILTERABLE_FIELDS.LAST_SEEN]: 'ls',
} as const satisfies Record<NetworkConnectionsFilterableField, string>;

export const NETWORK_DOMAINS_TABLE_CONFIG = {
  tableId: TABLE_IDS.ORGANIZATION.SHADOW_AI.NETWORK,
} as const;

export const NETWORK_DOMAINS_PAGE_SIZE = 20;
